import { SourcePill } from "./SourcePill";
import { FrostLayer } from "./FrostLayer";

export const SocialPortraitCard = ({ item, onOpen, onCta, eager = false, radius = 32, testId, className = "" }) => (
  <article
    data-testid={testId}
    className={`spc group relative aspect-[2/3] w-full overflow-hidden ${className}`}
    style={{ "--tint": item.tint, borderRadius: radius }}
  >
    <img
      src={item.image}
      alt={item.alt}
      loading={eager ? "eager" : "lazy"}
      fetchPriority={eager ? "high" : "auto"}
      decoding="async"
      width="800"
      height="1192"
      className="spc-img absolute inset-0 h-full w-full object-cover"
    />
    {onOpen && (
      <button
        type="button"
        onClick={onOpen}
        aria-label={`Preview ${item.title}`}
        data-testid={`${testId}-open`}
        className="absolute inset-0 z-[1] cursor-pointer focus-visible:outline-none"
      />
    )}
    <FrostLayer src={item.image} />
    <div className="spc-body pointer-events-none absolute inset-x-0 bottom-0 z-[2] flex flex-col items-center text-center">
      <SourcePill source={item.source} testId={`${testId}-label`} />
      {item.stat && (
        <div className="spc-stat-row">
          <span className="spc-stat">{item.stat}</span>
          <span className="spc-stat-label">{item.statLabel}</span>
        </div>
      )}
      <h3 className="spc-title">{item.title}</h3>
      <p className="spc-sub">{item.subtitle}</p>
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          (onCta || onOpen)?.();
        }}
        data-testid={`${testId}-cta`}
        className={`spc-cta spc-cta--${item.ctaStyle || "light"} pointer-events-auto`}
      >
        {item.cta}
      </button>
    </div>
  </article>
);
